import { useContext } from 'react';
import { FamiliesChartsDataContext } from '../contexts/FamiliesChartsDataContext';

export const useFamiliesChartsDataContext = () => {
    return useContext(FamiliesChartsDataContext);
};
